export default {
  props: {
    type: String,
    text: String,
    url: String,
    styleVariant: {
      type: String,
      default: '',
    },
  },
  computed: {
    isLink() {
      return this.type === 'link';
    },
    isButton() {
      return this.type === 'button';
    },
    isStoryFooterCta() {
      return this.styleVariant === 'story-footer-cta';
    },
    linkClass() {
      return {
        link: true,
        'link--regular': this.isLink,
        'link--story-footer-cta': this.isLink && this.isStoryFooterCta,
      };
    },
    displayText() {
      if (!this.isStoryFooterCta) {
        return this.text;
      }

      return (this.text || '').replace(/\s*→\s*$/, '').trim();
    },
  },
};
